export default {
  home: {
    title: 'ホーム',
    aiBannerTxt: {
      title: 'AI教育を実現する',
      subtitle: 'AI+教育のデジタル活用、革新的なコンセプトの融合',
      description: 'レーザーカスタマイズ製品と技術サービスに特化し、教育機関や企業の "AI+ Education" 統合を支援'
    },
    description: '私たちのVue.jsマーケティングサイトへようこそ',
    banner: {
      slide1: {
        title: 'STEAMキット | AIキット | レーザー切断キット',
        description:
          '家庭、教育者、ディストリビューター向けに革新的なSTEAM教育ソリューションと各種キットを提供しており、3歳から16歳の子ども向けに設計されています。',
      },
      slide2: {
        title: '専門キット、子どもの創造力のために設計',
        description:
          'コース、機器、ソフトウェアが一体化し、プロジェクト型学習を簡単に実施できます',
      },
      slide3: {
        title: '未来志向のテクノロジー教育',
        description:
          'ハンズオン実践、学際的融合により、問題解決力と協働能力を育成',
      },
    },
    factory: {
      banner: {
        alt: 'スマートファクトリーバナー',
        title: 'スマートファクトリーソリューション',
        description: '生産ライン構築｜産業用センサー｜PLC制御とデータ収集',
        image: 'https://picsum.photos/seed/factory-banner/1000/600',
      },
      resourcesTitle: '教育リソース',
      resources: [
        {
          title: 'プロジェクト型教材',
          desc: 'コースPPTと教材、授業活動設計と評価の提案。',
          image: 'https://picsum.photos/seed/factory-res-1/374/217',
        },
        {
          title: 'シナリオ例と素材',
          desc: 'コンベア制御、作業ステーション検出、設備連動などのサンプルとコードスニペット。',
          image: 'https://picsum.photos/seed/factory-res-2/374/217',
        },
        {
          title: '授業後の拡張タスク',
          desc: '拡張タスクと学際的応用の提案により、探究と創造を促進。',
          image: 'https://picsum.photos/seed/factory-res-3/374/217',
        },
      ],
      intro: {
        title: '製品紹介',
        desc: 'スマートファクトリーソリューションは、生産ライン構築とプログラミング制御を中心に、産業用センサー、作業ステーション認識、PLC/マイコン制御、データ収集などをカバーし、実践と体系的トレーニングを重視しています。',
        bg: 'https://picsum.photos/seed/factory-bg/1200/736',
      },
      course: {
        title: '対応コース',
        desc: '生産ライン構築、産業用センサー、PLC制御、データ収集などをテーマにしたプロジェクト型コースを設計し、実践と体系的トレーニングを重視。',
        image: 'https://picsum.photos/seed/factory-course/668/597',
      },
      equipments: [
        {
          title: 'コンベアモジュール',
          image: 'https://picsum.photos/seed/factory-eq-1/209/209',
        },
        {
          title: '光電センサー',
          image: 'https://picsum.photos/seed/factory-eq-2/209/209',
        },
        {
          title: 'PLC制御ユニット',
          image: 'https://picsum.photos/seed/factory-eq-3/209/209',
        },
        {
          title: 'ロボットアームモジュール',
          image: 'https://picsum.photos/seed/factory-eq-4/209/209',
        },
        {
          title: 'バーコード認識モジュール',
          image: 'https://picsum.photos/seed/factory-eq-5/209/209',
        },
        {
          title: '温湿度センサー',
          image: 'https://picsum.photos/seed/factory-eq-6/209/209',
        },
        {
          title: 'モータードライブモジュール',
          image: 'https://picsum.photos/seed/factory-eq-7/209/209',
        },
        {
          title: '作業ステーション検出モジュール',
          image: 'https://picsum.photos/seed/factory-eq-8/209/209',
        },
        {
          title: '安全非常停止モジュール',
          image: 'https://picsum.photos/seed/factory-eq-9/209/209',
        },
        {
          title: 'データ収集ゲートウェイ',
          image: 'https://picsum.photos/seed/factory-eq-10/209/209',
        },
      ],
    },
    solutions: {
      title: 'Zetok STEAM教育ソリューション',
      learnMore: '詳しく見る >',
      items: [
        {
          image: require('@/assets/home/solution1.webp'),
          title: 'Zetokキット',
          description:
            'ハンズオン操作とプロジェクト型学習を通じて、創造的思考と実践能力を養います。',
          link: '/solutions/kits',
        },
        {
          image: require('@/assets/home/solution2.webp'),
          title: 'Good Laser レーザー切断機＆彫刻機',
          description:
            'レーザー切断機がSTEAM教育に新しい実践学習体験を提供します',
          link: '/solutions/laser',
        },
      ],
    },
    scenes: {
      title: '教育シーン',
      items: [
        {
          image: require('@/assets/home/education1.webp'),
          title: 'STEM教育ソリューション',
        },
        {
          image: require('@/assets/home/education2.webp'),
          title: 'メイカースペースソリューション',
        },
      ],
    },
    aiBanner: {
      alt: 'AIバナー',
      image: require('@/assets/home/aibanner.png'),
    },
    kitsSection: {
      alt: 'Zetokキット',
      title: 'AIキット',
      description:
        'AIキットには通常、豊富なインタラクティブプロジェクトと実践的プロジェクトが含まれており、学生の科学技術への興味と好奇心を刺激します。',
      image: require('@/assets/home/kitsbanner.png'),
    },
    kitsCarousel: {
      alt: 'キットカルーセル',
      title: '創造的思考を高める',
      items: [
        { image: require('@/assets/home/kits1.png') },
        { image: require('@/assets/home/kits2.png') },
        { image: require('@/assets/home/kits3.png') },
        { image: require('@/assets/home/kits4.png') },
        { image: require('@/assets/home/kits5.png') },
        { image: require('@/assets/home/kits6.png') },
        { image: require('@/assets/home/kits7.png') },
        { image: require('@/assets/home/kits8.png') },
        { image: require('@/assets/home/kits9.png') },
      ],
    },
    products: {
      title: 'ZetokキットとGood Laserレーザー切断機',
      tabs: {
        kits: 'キット',
        courses: 'コース',
        laser: 'レーザー機器',
        software: 'ソフトウェア',
      },
      items: {
        kits: [
          {
            image: require('@/assets/home/product1.webp'),
            title: 'レーザー切断入門キット',
            description: '(木板消耗品付き)',
          },
          {
            image: require('@/assets/home/product2.webp'),
            title: 'ワンダーサイエンスボックス',
            description: '(木板＋電子回路キット付き)',
          },
          {
            image: require('@/assets/home/product3.webp'),
            title: 'AIプログラミングキット',
            description: '',
          },
        ],
        courses: [
          {
            image: require('@/assets/home/product4.webp'),
            title: '科学探究体系-幼児',
            description: '（6コース）',
          },
          {
            image: require('@/assets/home/product5.webp'),
            title: 'STEAMメイカー体系-青少年',
            description: '（3コース）',
          },
          {
            image: require('@/assets/home/product6.webp'),
            title: 'レーザー切断コース',
            description: '（3コース）',
          },
          {
            image: require('@/assets/home/product7.webp'),
            title: 'AIコース体系',
            description: '（4コース）',
          },
        ],
        laser: [
          {
            image: require('@/assets/home/product8.png'),
            title: 'Light 530',
            description: '55WデスクトップCo2レーザー切断機＆彫刻機',
          },
          {
            image: require('@/assets/home/product9.png'),
            title: 'Light 640',
            description: 'プロフェッショナルデスクトップレーザー切断機＆彫刻機',
          },
          {
            image: require('@/assets/home/product10.png'),
            title: 'Light Blue 530',
            description: 'スマートデスクトップブルーレーザー切断機＆彫刻機',
          },
          {
            image: require('@/assets/home/product11.png'),
            title: 'Mark M20',
            description: '高精度レーザーマーキング機',
          },
        ],
        software: [
          {
            image: require('@/assets/home/product12.png'),
            title: 'Zetok学習プラットフォーム',
            description: '',
          },
          {
            image: require('@/assets/home/product13.png'),
            title: 'Zetokクラウドプラットフォーム',
            description: '',
          },
          {
            image: require('@/assets/home/product14.png'),
            title: 'Light Maker',
            description: '',
          },
          {
            image: require('@/assets/home/product15.png'),
            title: 'mind+',
            description: '',
          },
          {
            image: require('@/assets/home/product16.png'),
            title: 'Arduino',
            description: '',
          },
        ],
      },
    },
  },

  switch_lang: 'English',
  nav: {
    products: '製品',
    smartFarm: 'スマート農場',
    smartHome: 'スマートホーム',
    smartTraffic: 'スマート交通',
    smartFactory: 'スマート工場',
    laserSteam: 'レーザー切断 STEAM キット',
    dreamScience: 'ドリームサイエンスキット',
    course: 'コース',
    device: 'デバイス',
    education: '教育ソリューション',
    stem: 'STEM教育ソリューション',
    maker: 'メイカースペースソリューション',
    software: 'ソフトウェア',
    service: 'サービスとサポート',
    afterSale: 'チュートリアルダウンロード',
    about: '私たちについて',
    aboutUs: '私たちについて',
    dealer: 'ディーラーになる',
    cooperation: '製品使用と教育協力',
    news: 'ニュース',
    coursesSeries: '4つのコースシリーズ',
    viewMore: 'もっと見る',
    store: 'ストア'
  },
  globalContactForm: {
    title: 'お問い合わせ',
    subtitle:
      'ご質問やご要望がございましたら、いつでもお気軽にお問い合わせください。心を込めて対応いたします。',
    fields: {
      name: 'お名前',
      email: 'メール',
      phone: '電話番号',
      company: '会社',
      message: 'メッセージ',
    },
    placeholders: {
      name: 'お名前を入力してください',
      email: 'メールアドレスを入力してください',
      phone: '電話番号を入力してください',
      company: '会社名を入力してください',
      message: 'ご要望やご質問をご記入ください',
    },
    validation: {
      name: 'お名前を入力してください',
      email: 'メールアドレスを入力してください',
      emailFormat: 'メールアドレスの形式が正しくありません',
      phone: '電話番号を入力してください',
      message: 'メッセージをご記入ください',
    },
    submit: '送信',
    submitting: '送信中…',
    visual: {
      title: '専門サービス',
      description:
        '3〜16歳の子ども向けの科学技術創造力教育に特化し、メイカースペースを運営し、関連製品やコースを開発。',
    },
    contact: {
      phone: 'サービスホットライン',
      email: 'メールアドレス',
    },
  },
  thankYou: {
    metaTitle: 'ありがとうございます',
    title: 'ご送信ありがとうございます！',
    description:
      'ご入力内容を受け取りました。追って担当者よりご連絡いたします。',
    seoDescription: '送信を受領しました。担当者がまもなくご連絡します。',
    backHome: 'ホームに戻る',
    browseProducts: '製品を閲覧',
    contactSupport: 'サポートに連絡',
    nextStepsTitle: '今後の流れ',
    nextSteps: [
      '当社チームが1〜2営業日以内に内容を確認します。',
      '必要に応じて、追加情報のご提供をお願いする場合があります。',
      '引き続き閲覧するか、電話・メールでお問い合わせいただけます。',
    ],
    contactTitle: 'お急ぎのご相談ですか？',
    contactPhoneLabel: 'サービスホットライン：',
    contactEmailLabel: 'メール：',
  },
  about: {
    banner: {
      alt: '私たちについてバナー',
      title: 'Zetokは革新的教育に注力し、高品質なキットとコースを提供',
      image: require('@/assets/about/banner.png'),
    },
    mission: {
      title: '私たちの使命',
      desc: '最先端の人工知能技術を通じて教育を強化し、創造力を引き出し、未来のリーダーやイノベーターを育成することが私たちの使命です。高品質な教育ツールとソリューションを提供することで、学生や教育者が潜在能力を最大限に発揮できると信じています。',
      image: require('@/assets/about/mission.png'),
    },
    vision: {
      title: '私たちのビジョン',
      desc: 'テクノロジーで教育を強化し、すべての学生が質の高いSTEM資源を利用できるようにし、潜在能力を引き出し、未来のイノベーターやリーダーを育成します。',
      image: require('@/assets/about/vision.png'),
    },
    products: {
      title: '私たちの製品',
      tabs: ['キット', 'コース', 'レーザー機器'],
      items: [
        {
          title: 'キット',
          desc: '人工知能、ロボティクス、プログラミング、科学実験など、多様なSTEMキットを提供。精巧で使いやすく、異なる年齢層の学生に適しています。',
          image: require('@/assets/about/kits.png'),
        },
        {
          title: 'コース',
          desc: '教育専門家が設計したコースで、キットと組み合わせて包括的な学習体験を提供。基礎概念から高度な応用までカバーし、学習者のレベルに対応。',
          image: require('@/assets/about/courses.png'),
        },
        {
          title: 'レーザー機器',
          desc: '安全で使いやすいレーザー切断/彫刻機。教育環境向けに設計され、安全で正確、操作も簡単です。学生は創造力を実物に変えることができます。',
          image: require('@/assets/about/laser.png'),
        },
      ],
    },
    dealer: {
      banner: {
        alt: 'Zetokのディーラーに参加',
        title: 'Zetokのディーラーに参加',
        image: require('@/assets/about/dealer.png'),
      },
      intro: {
        title:
          '教育の新しいビジネスチャンスを開拓し、イノベーションの成果を共有！',
        desc: 'ZetokはSTEM教育の新しい道を共に切り開き、AIキット、レーザー機器などを提供し、学生の創造力を刺激します。ぜひ加盟して共に未来を築きましょう！',
        image: require('@/assets/about/dealer1.png'),
      },
      mission: {
        title: '私たちの使命',
        items: [
          {
            title: '先進製品',
            desc: '市場で優れたSTEAM教育ツールを入手。',
            image: require('@/assets/about/dealer-mission-1.png'),
          },
          {
            title: '豊富なリターン',
            desc: '競争力のある割引と販売インセンティブを享受。',
            image: require('@/assets/about/dealer-mission-2.png'),
          },
          {
            title: '市場サポート',
            desc: 'マーケティング資料と販売トレーニングを提供し、市場参入を支援。',
            image: require('@/assets/about/dealer-mission-3.png'),
          },
          {
            title: 'ブランド協力',
            desc: 'Zetokと提携し、ブランド影響力と市場資源を共有。',
            image: require('@/assets/about/dealer-mission-4.png'),
          },
        ],
      },
    },
    cooperation: {
      banner: {
        alt: '協力バナー',
        title: '製品協力',
        cta: '今すぐお問い合わせ',
        ctaLink: '/about#contact',
        image: require('@/assets/about/coop-introbanner.png'),
      },
      intro: {
        title: '未来の科学者とエンジニアの潜在能力を引き出す',
        desc: 'STEM教育推進プログラムに参加し、教育者向けの特別割引や製品試用を利用できます。教室向けの革新的STEMツールと独自の割引で、次世代のイノベーターと問題解決者を育成。',
        image: require('@/assets/about/coop-introbanner1.png'),
      },
      stem: {
        title: '今すぐ行動して、STEM教育の新章を開こう！',
        items: [
          {
            title: '製品無料試用',
            desc: '購入前にツールを体験できます。',
            image: require('@/assets/about/edu1.png'),
          },
          {
            title: '独占割引',
            desc: '教室や学校向けに経済的なSTEMソリューションを提供。',
            image: require('@/assets/about/edu2.png'),
          },
          {
            title: '教育リソース',
            desc: '豊富な教材やコースプランを提供し、教育活動をサポート。',
            image: require('@/assets/about/edu3.png'),
          },
        ],
      },
      contact: {
        title: 'お問い合わせ',
        desc: 'ご質問やご要望がございましたら、お気軽にお問い合わせください。心を込めて対応いたします。',
        image: require('@/assets/about/kites.png'),
      },
    },
    news: {
      banner: {
        alt: 'ニュースセンターバナー',
        title: 'ニュースセンター',
        image: require('@/assets/about/newsbanner.png'),
      },
      title: 'ニュースセンター',
      tabs: [
        { key: 'company', label: '会社ニュース' },
        { key: 'industry', label: '業界ニュース' },
        { key: 'expo', label: '展示会ニュース' },
      ],
      data: {
        company: [
          {
            id: 'company-1',
            title: 'Zetok、新しい教室向けAIキットを発表',
            date: '2025-04-22',
            image: 'https://picsum.photos/seed/news-company-1-zh/560/342',
          },
          {
            id: 'company-2',
            title: '地元学校とSTEMプロジェクトを試行',
            date: '2025-04-15',
            image: 'https://picsum.photos/seed/news-company-2-zh/560/342',
          },
          {
            id: 'company-3',
            title: 'ソフトウェア更新で教室管理体験を向上',
            date: '2025-03-30',
            image: 'https://picsum.photos/seed/news-company-3-zh/560/342',
          },
          {
            id: 'company-4',
            title: '教師向けトレーニングワークショップを開催',
            date: '2025-03-18',
            image: 'https://picsum.photos/seed/news-company-4-zh/560/342',
          },
          {
            id: 'company-5',
            title: 'ディーラーネットワークを拡大',
            date: '2025-03-02',
            image: 'https://picsum.photos/seed/news-company-5-zh/560/342',
          },
          {
            id: 'company-6',
            title: '新しいコースシリーズ、実践プロジェクトに注力',
            date: '2025-02-20',
            image: 'https://picsum.photos/seed/news-company-6-zh/560/342',
          },
          {
            id: 'company-7',
            title: '年間レビューでイノベーション成果を強調',
            date: '2025-02-05',
            image: 'https://picsum.photos/seed/news-company-7-zh/560/342',
          },
          {
            id: 'company-8',
            title: 'コミュニティ公益プログラムでSTEMを青少年に提供',
            date: '2025-01-25',
            image: 'https://picsum.photos/seed/news-company-8-zh/560/342',
          },
        ],
        industry: [
          {
            id: 'industry-1',
            title: '世界のトレンド：STEMにおけるプロジェクト型学習の活用',
            date: '2025-04-10',
            image: 'https://picsum.photos/seed/news-industry-1-zh/560/342',
          },
          {
            id: 'industry-2',
            title: '教育におけるAI：現れつつあるベストプラクティス',
            date: '2025-03-25',
            image: 'https://picsum.photos/seed/news-industry-2-zh/560/342',
          },
          {
            id: 'industry-3',
            title: '新しい教育基準では実践能力を重視',
            date: '2025-03-12',
            image: 'https://picsum.photos/seed/news-industry-3-zh/560/342',
          },
          {
            id: 'industry-4',
            title: '教育ハードウェアが教室ニーズにより適合',
            date: '2025-02-28',
            image: 'https://picsum.photos/seed/news-industry-4-zh/560/342',
          },
          {
            id: 'industry-5',
            title: '各学区でSTEAMプロジェクトが継続展開',
            date: '2025-02-14',
            image: 'https://picsum.photos/seed/news-industry-5-zh/560/342',
          },
          {
            id: 'industry-6',
            title: '持続可能な開発プロジェクトがSTEM教室へ',
            date: '2025-01-30',
            image: 'https://picsum.photos/seed/news-industry-6-zh/560/342',
          },
          {
            id: 'industry-7',
            title: 'メイカースペースが革新的学習に影響',
            date: '2025-01-16',
            image: 'https://picsum.photos/seed/news-industry-7-zh/560/342',
          },
        ],
        expo: [
          {
            id: 'expo-1',
            title: 'Zetok、教育テクノロジー展示会に出展',
            date: '2025-04-05',
            image: 'https://picsum.photos/seed/news-expo-1-zh/560/342',
          },
          {
            id: 'expo-2',
            title: '地域展示会で学生プロジェクト成果を展示',
            date: '2025-03-22',
            image: 'https://picsum.photos/seed/news-expo-2-zh/560/342',
          },
          {
            id: 'expo-3',
            title: 'メイカーイベントでのインタラクティブデモが注目',
            date: '2025-03-08',
            image: 'https://picsum.photos/seed/news-expo-3-zh/560/342',
          },
          {
            id: 'expo-4',
            title: '教師向けビジュアルプログラミングワークショップ',
            date: '2025-02-21',
            image: 'https://picsum.photos/seed/news-expo-4-zh/560/342',
          },
          {
            id: 'expo-5',
            title: '新しい機器を教育パートナー向けに展示',
            date: '2025-02-09',
            image: 'https://picsum.photos/seed/news-expo-5-zh/560/342',
          },
        ],
      },
    },
  },
  finance: {
    contact: {
      success: '送信成功しました。できるだけ早くご連絡いたします。',
      error: '送信に失敗しました。後でもう一度お試しください。',
      networkError: 'ネットワークエラー。接続を確認して再試行してください。',
    },
  },
  footer: {
    subscribePlaceholder: '電話番号またはメールアドレス',
    subscribe: '購読',
    subscribeSuccess: '購読成功',
    contact: {
      sales: '営業ホットライン：+86 18379276683',
      service: 'サービスホットライン：+86 400 968 0598',
      email: 'メール：sam@zz-steam.com',
      address: '住所：深圳市福田区 八卦四路 華晟達ビル A棟',
    },
    icp: 'プライバシーポリシー·利用規約 © 中泽教育（深圳）有限公司 粤ICP备2024289240号-3',
  },

  solutions: {
    stem: {
      banner: {
        alt: 'STEM教育ソリューションバナー',
        title: 'STEM教育の創造的リーダーシップ',
        description:
          'K12向けに、創造的なSTEM教育に注力し、探求心を刺激し、論理力を育み、プログラミングへの情熱を喚起します。',
        image: require('@/assets/solution/banner.png'),
      },
      intro: {
        title: '人工知能とプログラミング教育',
        items: [
          {
            icon: require('@/assets/solution/icon1.png'),
            title: '学びやすく使いやすい',
            description:
              'ビジュアルプログラミングで初心者でもすぐに使え、専用AIプロジェクトを簡単に作成可能。',
          },
          {
            icon: require('@/assets/solution/icon2.png'),
            title: '高機能',
            description:
              'スマートハードウェア、音声インタラクション、無限の創造性。',
          },
          {
            icon: require('@/assets/solution/icon3.png'),
            title: '拡張性',
            description: 'ハードウェア接続で想像力を広げ、無限の創造を実現。',
          },
          {
            icon: require('@/assets/solution/icon4.png'),
            title: '豊富なカリキュラム',
            description:
              '基礎から実践までのサポートコースで、学生が知識体系を構築するのを支援。',
          },
        ],
      },
      scenes: {
        title: '特徴的なカリキュラムを知る',
        items: [
          {
            tab: '学校教育',
            title: 'AI学校教育',
            desc: 'AIキットでスマート音声アシスタントを作成し、実践を通じて興味を喚起し、論理力とプログラミング能力を育成。',
            image: require('@/assets/solution/tc1.png'),
          },
          {
            tab: 'コンテスト研修',
            title: 'コンテスト研修',
            desc: 'スマートキットでロボットコンテストや科学技術創造活動を支援し、学生が協力と創造力を向上させる。',
            image: require('@/assets/solution/tc2.png'),
          },
          {
            tab: '家庭学習',
            title: '家庭学習',
            desc: '親子でAIプロジェクトを学習し、実践力を養い、親子関係を深め、科学技術リテラシーを向上。',
            image: require('@/assets/solution/tc3.png'),
          },
        ],
      },
      split: {
        title: 'AI＋教育：スマートラーニングの新時代を開く',
        desc: 'AI技術を活用して個別学習パスを提供し、正確な指導を行い、すべての学生が知識の海を自由に探索できるようにします。',
        image: require('@/assets/solution/banner1.png'),
      },
      kits: {
        title: 'STEMシリーズキット',
        images: [
          require('@/assets/solution/kits1.png'),
          require('@/assets/solution/kits2.png'),
          require('@/assets/solution/kits3.png'),
          require('@/assets/solution/kits4.png'),
        ],
      },
    },
    makerSpace: {
      banner: {
        alt: 'メイカースペースソリューションバナー',
        title: 'メイカースペースを探求',
        description:
          'メイカースペースで教育と革新的技術を組み合わせ、学生に実践と探求の場を提供。',
        image: require('@/assets/solution/spacebanner.png'),
      },
      intro: {
        title: '包括的なメイカースキル',
        items: [
          {
            icon: require('@/assets/solution/icon5.png'),
            title: '技術ツールの活用',
            desc: 'ビジュアルプログラミングで初心者でも簡単にAIプロジェクトを作成可能。',
          },
          {
            icon: require('@/assets/solution/icon6.png'),
            title: '開放性と柔軟性',
            desc: 'メイカースペースは自由に探求でき、創造性を解放する専用の場所。',
          },
          {
            icon: require('@/assets/solution/icon7.png'),
            title: 'ハンズオン実践',
            desc: '制作・実験・探求を通して学習の旅を開始。',
          },
          {
            icon: require('@/assets/solution/icon8.png'),
            title: '協働学習',
            desc: '学生がチームで協力することを奨励し、協働力とコミュニケーション能力を育成。',
          },
        ],
      },
      scenes: {
        title: 'メイカースペースの利用シーン',
        items: [
          {
            tab: '学校手作り授業',
            title: '学校手作り授業',
            desc: '手工芸、美術デザイン等の授業の強力な補完。',
            image: require('@/assets/solution/tc4.png'),
          },
          {
            tab: '創研実践クラブ',
            title: '創研実践クラブ',
            desc: '学校のイノベーション実践クラブのための実践プラットフォーム。',
            image: require('@/assets/solution/tc5.png'),
          },
          {
            tab: '教育ラボ',
            title: '教育ラボ',
            desc: '学校、大学、ラボ向け。学習環境を更新し、学生に専門的なレーザー彫刻機を提供。',
            image: require('@/assets/solution/tc6.png'),
          },
        ],
      },
      split: {
        title: '創造を実現するツール',
        desc: 'レーザー切断機の精密切断とプログラミングロボットのインタラクティブ機能を活用して、学生は抽象的なアイデアを具体的な作品に変換できます。',
        image: require('@/assets/solution/banner2.png'),
      },
      kits: {
        title: 'メイカーズシリーズキット',
        images: [
          require('@/assets/solution/kits5.png'),
          require('@/assets/solution/kits6.png'),
          require('@/assets/solution/kits7.png'),
          require('@/assets/solution/kits8.png'),
        ],
      },
    },
  },

  software: {
    banner: {
      alt: 'ソフトウェアページバナー',
      title: 'Zetokソフトウェアセンター',
      image: require('@/assets/software/banner.png'),
    },
    download: {
      title: 'ソフトウェアダウンロード',
      items: [
        {
          key: 'lightmaker-app',
          icon: 'https://picsum.photos/seed/sw-app-1/88/88',
          name: 'Light maker App',
          buttonText: 'モバイル端末ダウンロード',
          link: '#',
        },
        {
          key: 'goodlaser-lightmaker',
          icon: 'https://picsum.photos/seed/sw-app-2/88/88',
          name: 'Good-laser Light maker',
          buttonText: 'クライアントダウンロード',
          link: '#',
        },
        {
          key: 'zz-learning-app',
          icon: 'https://picsum.photos/seed/sw-app-3/88/88',
          name: 'Zetok学習プラットフォームApp',
          buttonText: 'モバイル端末ダウンロード',
          link: '#',
        },
        {
          key: 'zz-learning-platform',
          icon: 'https://picsum.photos/seed/sw-app-4/88/88',
          name: 'Zetok学習プラットフォーム',
          buttonText: 'クライアントダウンロード',
          link: '#',
        },
      ],
    },
    intro: {
      'goodlaser-lightmaker': {
        header: {
          title: 'Light Maker レーザー機器専用ソフト',
          desc: 'グラフィックデザインと機器制御を統合し、ユーザーの時間を節約するオールインワン設計・レーザー制御ソリューション。',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-1/514/403',
            title: '高機能で使いやすいデザインシステム',
            desc: '強力なクリエイションソフトで、JPG、DXF、AI、DST、PNG、BMP、TIF、SVG形式の高品質デザインに対応。',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-2/514/403',
            title: 'プロ仕様',
            desc: '専門的な描画機能であらゆる制作ニーズに対応。複雑なデザインでも簡単に切断可能。',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-3/514/403',
            title: '操作が簡単',
            desc: 'ユーザーフレンドリーなインターフェイスで、複数のレーザー機器に対応。多機能・高効率な切断と彫刻処理。',
          },
        ],
      },
      'lightmaker-app': {
        header: {
          title: 'Zetokクラウドプラットフォーム',
          desc: '教育管理の革新的ツールで、教師、学生、学校向けにワンストップソリューションを提供。課題配信、機器監視、修理依頼、パラメータ設定を簡単に実行可能。',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-app-1/514/403',
            title: '便利な操作',
            desc: 'ワンクリック制作：内蔵ライブラリとパラメータ設定で簡単制作。機器監視：リアルタイムで機器状態を監視。',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-app-2/514/403',
            title: '統合管理',
            desc: '他の教室機器との接続管理をサポート、一括管理で効率アップ。',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-app-3/514/403',
            title: 'リアルタイム監視',
            desc: '機器状態をリアルタイムで把握し、故障時に即報修。稼働時間と使用頻度に応じて保守提示。',
          },
        ],
      },
      'zz-learning-app': {
        header: {
          title: 'Zetokクラウドプラットフォーム',
          desc: '教育管理の革新的ツールで、教師、学生、学校向けにワンストップソリューションを提供。課題配信、機器監視、修理依頼、パラメータ設定を簡単に実行可能。',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-app-1/514/403',
            title: '便利な操作',
            desc: 'ワンクリック制作：内蔵ライブラリとパラメータ設定で簡単制作。機器監視：リアルタイムで機器状態を監視。',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-app-2/514/403',
            title: '統合管理',
            desc: '他の教室機器との接続管理をサポート、一括管理で効率アップ。',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-app-3/514/403',
            title: 'リアルタイム監視',
            desc: '機器状態をリアルタイムで把握し、故障時に即報修。稼働時間と使用頻度に応じて保守提示。',
          },
        ],
      },
      'zz-learning-platform': {
        header: {
          title: 'Zetok学習プラットフォーム ソフト紹介',
          desc: 'コース管理、課題配信、評価分析を提供する統合プラットフォーム。現状はプレースホルダ文、後で詳細差し替え可能。',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-web-1/514/403',
            title: 'コース管理と公開',
            desc: '教育コンテンツとリソースを集中管理、多様な素材と形式に対応。',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-web-2/514/403',
            title: '授業データ分析',
            desc: '学習データと評価結果を可視化し、教育判断を支援。',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-web-3/514/403',
            title: 'マルチデバイス協働',
            desc: 'Appや機器と連携して、授業と実践を接続。',
          },
        ],
      },
    },
  },
  product: {
    farm: {
      banner: {
        alt: 'スマートファームバナー',
        title: 'スマートファーム学習キット',
        btnText: '今すぐ購入',
        description:
          'プロジェクト型学習 | プログラミング+ハードウェア+AI | 小中学生向け',
        image: require('@/assets/product/farm/banner.png'),
      },
      sections: {
        courseTitle: 'プロジェクトコース内容',
        resourceTitle: '教育リソース',
        equipmentsTitle: '器材構成',
      },
      courses: [
        {
          bg: '#FBBC05',
          txt: '#fff',
          title: '豊富で多様なコース内容',
          desc: '12コースを段階的に学習：温度検知からスマート灌漑、温度制御まで、一気にステップアップ。',
          image: require('@/assets/product/farm/education1.png'),
        },
        {
          bg: '#4285F4',
          txt: '#fff',
          title: '学際的知識の融合',
          desc: '各プロジェクトにはプログラミング、電子ハードウェア、機械構造などの多分野知識が含まれ、実践を通して統合的に活用する能力と学際的思考力を育てます。',
          image: require('@/assets/product/farm/education2.png'),
        },
        {
          bg: '#EA4335',
          txt: '#fff',
          title: '生活に密着したテーマ',
          desc: 'スマートファームをテーマに、学生の生活に近く、学習意欲と参加意欲を刺激しやすい。',
          image: require('@/assets/product/farm/education3.png'),
        },
      ],
      resources: [
        {
          title: '完全な授業用PPTと教材',
          desc: '16回分の授業PPTと教材は、教育プロジェクトと密接に対応しており、教師に豊富な教材を提供し、準備の負担を軽減します。',
          image: require('@/assets/product/farm/edu1.png'),
        },
        {
          title: 'プロジェクト型コースの組立動画',
          desc: '動画資料はプロジェクトの組立過程を直感的に示し、学生が手順を理解・習得しやすく、学習効率を向上させます。',
          image: require('@/assets/product/farm/edu2.png'),
        },
        {
          title: '補助教材',
          desc: '教材などの補助資料は学生に詳細な学習指導を提供し、復習や自主学習に便利です。',
          image: require('@/assets/product/farm/edu3.png'),
        },
      ],
      equipments: [
        {
          title: 'RGBライトテープ',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'DS1307時計モジュール',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'DHT11温湿度センサー',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: '人体感知センサー',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'LED照明モジュール',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'ファンモジュール',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'スロット型光カプラー',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'ボタンモジュール',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'コントロールボード',
          image: require('@/assets/product/kits/kits7.png'),
        },
        { title: '拡張版', image: require('@/assets/product/kits/kits6.png') },
      ],
    },

    home: {
      banner: {
        alt: 'スマートホーム学習キット',
        title: 'スマートホーム学習キット',
        btnText: '今すぐ購入',
        description:
          'プログラミングとAI入門 | プロジェクト型学習 | 小中学生向けSTEM授業の最適解',
        image: require('@/assets/product/home/banner.png'),
      },
      resourcesTitle: 'スマートホーム入門キットの利点',
      resources: [
        {
          title: '豊富なリソース',
          desc: '完全な教材を提供し、教師の指導と学生の学習をサポート。',
          image: require('@/assets/product/home/adv1.png'),
        },
        {
          title: '学際的融合',
          desc: '各プロジェクトにはプログラミング、電子ハードウェア、機械構造などの多分野知識が含まれ、実践を通じて統合的に活用する能力を育成。',
          image: require('@/assets/product/home/adv2.png'),
        },
        {
          title: '課後の拡張タスク',
          desc: '拡張課題と学際的応用の提案で探究と創造を促進。',
          image: require('@/assets/product/home/adv3.png'),
        },
      ],
      course: {
        title: '対応コース',
        desc: '12の精選プロジェクトコースを含み、スマートホームの各側面をカバー：電子ドアベル、調光前灯、センサー付きガレージ、暗証番号アクセス、ガス警報、防犯アラーム、カラフル照明、音楽ムードライト、日光検知、室温検知、温度制御ファンなど。',
        image: require('@/assets/product/home/banner2.png'),
      },
      scenesTitle: '多様な応用シーン',
      scenes: [
        {
          title: '授業での活用',
          image: require('@/assets/product/home/c1.png'),
        },
        {
          title: '独立創造開発',
          image: require('@/assets/product/home/c2.png'),
        },
        {
          title: '家庭での親子体験',
          image: require('@/assets/product/home/c3.png'),
        },
        {
          title: 'イベント展示',
          image: require('@/assets/product/home/c4.png'),
        },
      ],
      equipmentsTitle: '器材構成',
      equipments: [
        {
          title: 'RGBライトテープ',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'DS1307時計モジュール',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'DHT11温湿度センサー',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: '人体感知センサー',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'LED照明モジュール',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'ファンモジュール',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'スロット型光カプラー',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'ボタンモジュール',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'コントロールボード',
          image: require('@/assets/product/kits/kits7.png'),
        },
        { title: '拡張版', image: require('@/assets/product/kits/kits6.png') },
      ],
    },

    factory: {
      banner: {
        alt: 'スマートファクトリーバナー',
        title: 'スマートファクトリー学習キット',
        btnText: '今すぐ購入',
        description: ` · センサー/制御/駆動を網羅 <br>
 · 実際の生産ラインをシミュレーション<br>
 · "未来のエンジニア"を育成`,
        image: require('@/assets/product/factory/banner.png'),
      },
      resourcesTitle: '製品の特徴',
      resources: [
        {
          title: 'Industry 4.0の体験',
          desc: '学生は模擬生産ラインでセンサー、制御、駆動、データ管理を練習します。',
          image: require('@/assets/product/factory/tc1.png'),
        },
        {
          title: 'プロジェクト型学習',
          desc: 'プログラミングチュートリアルとPPT付き12回分のコースを含み、学習をサポート。',
          image: require('@/assets/product/factory/tc2.png'),
        },
        {
          title: 'リアルなシナリオをシミュレーション',
          desc: 'スマートアーム、オート仕分けシステム、スマート倉庫などで物流在庫管理をシミュレーション、STEM実践を体験。',
          image: require('@/assets/product/factory/tc3.png'),
        },
      ],
      intro: {
        title: '製品概要',
        desc: 'スマートファクトリー学習キットは、プログラミング、電子ハードウェア、機械構造、レーザーカット、AI教育を組み合わせたプロジェクト型学習キットで、小中学生向け。テーマは「スマート製造・未来の創造」で、模擬生産環境を通じて科学探究、エンジニアリング設計、プログラミング制御、協働イノベーション能力を養います。',
        bg: require('@/assets/product/factory/product.png'),
      },
      course: {
        title: '対応コース',
        desc: '12の精選コース：スマートファクトリー入門、生産工程理解、センサー応用、機械駆動基礎、搬送システム構築、自動仕分け、作業ステーション協働制御、組立ロボット、スマート仕分けなど。制御とデータ収集のプロジェクト型コースで、実践とシステム訓練を重視。',
        image: require('@/assets/product/factory/course.png'),
      },
      equipmentsTitle: '器材構成',
      equipments: [
        {
          title: 'RGBライトテープ',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'DS1307時計モジュール',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'DHT11温湿度センサー',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: '人体感知センサー',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'LED照明モジュール',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'ファンモジュール',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'スロット型光カプラー',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'ボタンモジュール',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'コントロールボード',
          image: require('@/assets/product/kits/kits7.png'),
        },
        { title: '拡張版', image: require('@/assets/product/kits/kits6.png') },
      ],
    },

    kits: {
      laserSteam: {
        banner: {
          alt: 'レーザーカットSTEAMキット バナー',
          title: 'レーザーカットSTEAMキット',
          btnText: '今すぐ購入',
          description: '創造力とチーム協働を育成する一体型教育ソリューション',
          image: require('@/assets/product/laser-steam/banner.png'),
        },
        resourcesTitle: 'レーザーカットSTEAMキットの利点',
        resources: [
          {
            title: '多重知能理論',
            desc: '多重知能理論に基づき、創造力、批判的思考、問題解決、コミュニケーション能力を養います。',
            image: require('@/assets/product/laser-steam/adv1.png'),
          },
          {
            title: 'プロジェクト型学習',
            desc: 'プロジェクト型学習を通じて実践的に学び、学習効率と興味を向上。',
            image: require('@/assets/product/laser-steam/adv2.png'),
          },
          {
            title: 'STEAM教育',
            desc: '科学、技術、工学、芸術、数学を統合し、学際的思考を育成。',
            image: require('@/assets/product/laser-steam/adv3.png'),
          },
        ],
        teach: {
          title: '詳細な教材',
          tabs: [
            { key: 'cutter', label: 'レーザーカッター' },
            { key: 'lesson', label: 'コース' },
            { key: 'material', label: '教材' },
            { key: 'software', label: 'ソフトウェア' },
          ],
          images: {
            cutter: require('@/assets/product/laser-steam/cutter.png'),
            lesson: require('@/assets/product/laser-steam/lesson.png'),
            material: require('@/assets/product/laser-steam/material.png'),
            software: require('@/assets/product/laser-steam/software.png'),
          },
        },
        aiBanner: {
          title: 'AI教育、スマートなスタート',
          desc: 'STEAM教育にAI要素を取り入れ、充実した学習体験を実現。',
        },
        equipmentsTitle: '器材構成',
      },
      dreamScience: {
        banner: {
          alt: 'ドリームサイエンスキット バナー',
          title: 'ドリームサイエンスキット',
          description: '基礎科学|科学的思考|探究実践|態度と責任',
          image: require('@/assets/product/dream-science/banner.png'),
        },
        resourcesTitle: 'キット内容',
        resources: [
          {
            title: '科学実験材料',
            desc: 'さまざまな科学実験とプロジェクトに使用。',
            image: require('@/assets/product/dream-science/kits1.png'),
          },
          {
            title: '教材',
            desc: '授業用PPTと教材を含み、1学期分の授業活動をサポート。内容はプロジェクトと知識点に対応。',
            image: require('@/assets/product/dream-science/kits2.png'),
          },
          {
            title: '組立動画と教材',
            desc: '補助教材で学生が手順を理解・習得しやすくします。',
            image: require('@/assets/product/dream-science/kits3.png'),
          },
        ],
        objectivesTitle: '教育目標',
        objectives: [
          {
            title: '科学探究能力',
            desc: '問題提起、計画立案、データ収集・分析',
            image: require('@/assets/product/dream-science/education1.png'),
          },
          {
            title: 'エンジニアリング実践能力',
            desc: '手を動かして組立とテストを行い、改善を繰り返す',
            image: require('@/assets/product/dream-science/education2.png'),
          },
          {
            title: '学際的融合',
            desc: '数学、物理、芸術を組み合わせてプロジェクトを完成',
            image: require('@/assets/product/dream-science/education3.png'),
          },
        ],
        intro: {
          title: '対象者',
          description:
            '小中学生：年齢に応じた学習で科学リテラシーと実践力を向上。教師：教材と指導を提供し、授業活動をサポート。',
          image: require('@/assets/product/dream-science/banner1.png'),
          alt: '紹介画像',
        },
      },
    },

    // 查看所有套件页面
    kitsViewAll: {
      banner: {
        alt: 'すべてのキットを見る バナー',
        title: 'キットシリーズ',
        image: require('@/assets/product/kitsall/banner.png'),
      },
      contentTitle:
        'プロジェクトを中心に、学生はさまざまなプロジェクト課題を通じて、知識を総合的に活用して問題を解決する能力を養います。',
      moreText: 'もっと詳しく',
      items: [
        {
          image: require('@/assets/product/kitsall/kits1.png'),
          title: 'スマートファーム学習キット',
          desc: 'プロジェクトを中心に、学生の創造力と実践能力を刺激し、実際の問題解決スキルを育成します。',
          link: '/products/laser-steam',
        },
        {
          image: require('@/assets/product/kitsall/kits2-1.png'),
          title: 'スマートホーム学習キット',
          desc: 'プログラミング、電子ハードウェア、機械構造、レーザーカット、人工知能の普及教育を組み合わせ、包括的な学習体験を提供します。',
          link: '/products/dream-science',
        },
        {
          image: require('@/assets/product/kitsall/kits2-2.png'),
          title: 'スマート交通学習キット',
          desc: 'プログラミング、電子ハードウェア、機械構造、レーザーカット、人工知能の普及教育を統合したプロジェクト型学習キットです。',
          link: '/products',
        },
        {
          image: require('@/assets/product/kitsall/kits2-3.png'),
          title: 'スマートファクトリー学習キット',
          desc: '人工知能の基礎知識と実際の事例をカバーし、段階的に学生を導き、体系的な知識構築を支援します。',
          link: '/products/traffic',
        },
        // {
        //   image: require('@/assets/product/kitsall/kits2.png'),
        //   title: 'レーザーカットSTEAMキット',
        //   desc: 'レーザーカットSTEAMコースキットは、多重知能理論、STEAM教育理念、プロジェクト型学習理論に基づいて設計されています。',
        //   link: '/products/home',
        // },
        // {
        //   image: require('@/assets/product/kitsall/kits2.png'),
        //   title: 'ドリームサイエンスキット',
        //   desc: '異なる学習段階のニーズに対応し、学生の科学への興味と探究心を刺激します。',
        //   link: '/products/farm',
        // },
      ],
    },

    traffic: {
      banner: {
        alt: 'スマート交通バナー',
        title: 'スマート交通学習キット',
        btnText: '今すぐ購入',
        description: `12のプロジェクト型コース
  <br>· グラフィカル/Python二重プログラミング
  <br>· 実際のシナリオシミュレーション
  <br>· 即開即教`,
        image: require('@/assets/product/traffic/banner.png'),
      },
      resourcesTitle: '製品の特徴',
      resources: [
        {
          title: '科学探究と創造性',
          desc: '学生は電子モジュールと機械構造を使ってスマート交通システムを構築します。',
          image: require('@/assets/product/traffic/traffic1.png'),
        },
        {
          title: '教育性が高い',
          desc: 'スマート街路灯、信号機、横断歩道、駐車場などのプロジェクトを構築し、学生にスマート交通の概念を理解させます。',
          image: require('@/assets/product/traffic/traffic2.png'),
        },
        {
          title: '豊富なリソース',
          desc: '12回分のPPTと教材、プロジェクト型コースの組立動画や補助資料など、完全な教育リソースが付属します。',
          image: require('@/assets/product/traffic/traffic3.png'),
        },
      ],
      intro: {
        title: '製品概要',
        desc: 'スマート交通中小学校用キットは「スマートモビリティ」と「交通安全」をテーマに、電子制御やセンサー技術を組み合わせ、学生が自ら設計・構築し、実際の交通シナリオをシミュレーションして科学リテラシーと創造力を養います。',
        bg: require('@/assets/product/traffic/banner1.png'),
      },
      course: {
        title: '対応コース',
        desc: '交通認知と制御の基礎、信号連動、経路計画などをテーマとしたプロジェクト型コースで、異なる学習段階と授業時間に対応します。',
        image: require('@/assets/product/traffic/course.png'),
      },
      equipmentsTitle: '器材構成',
      equipments: [
        {
          title: 'RGBライトテープ',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'DS1307時計モジュール',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'DHT11温湿度センサー',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: '人体感知センサー',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'LED照明モジュール',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'ファンモジュール',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'スロット型光カプラー',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'ボタンモジュール',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'コントロールボード',
          image: require('@/assets/product/kits/kits7.png'),
        },
        { title: '拡張版', image: require('@/assets/product/kits/kits6.png') },
      ],
    },

    banner: {
      alt: '製品ホームバナー',
      title: 'Zetok 製品とソリューション',
      description:
        'キット、コース、デバイスとソフトウェアの統合、プロジェクト型学習をサポート',
      image: 'https://picsum.photos/id/1069/1600/900',
    },

    courses: {
      banner: {
        alt: 'コースバナー',
        title: '4大コース体系',
        description:
          'コース内容は科学、技術、工学、芸術、数学（STEAM）など複数の学問分野をカバーし、学生の学際的知識の統合と応用を促進します。',
        image: require('@/assets/product/courses/banner.png'),
      },
      design: {
        title: '当社の特色コースを知る',
        nav: ['年齢3-6歳', '年齢6-12歳', '年齢8-13歳', '年齢9-15歳'],
        entries: [
          {
            title: '科学探究体系・幼児（6コース）',
            desc: '日常の現象を通じて、科学教材を活用してさらに探究し、物事の発展の規則と原理を理解します。',
            image: require('@/assets/product/courses/courses1.png'),
          },
          {
            title: 'STEAMクリエイター体系・青少年（3コース）',
            desc: '自身の創造力を発揮し、機器を使って実践し、創意を作品に変換します。',
            image: require('@/assets/product/courses/courses2.png'),
          },
          {
            title: 'レーザーカットコース体系（3コース）',
            desc: '機器を使って異なる構造部品を切断し、立体構造に組み立て、美化します。プログラミング能力：論理判断の原理を理解します。',
            image: require('@/assets/product/courses/courses3.png'),
          },
          {
            title: '人工知能コース体系（4コース）',
            desc: '機器ツールを使って作品の外観を設計・制作し、プログラミングで作品を知能化・簡略化し、日常の問題解決に活用します。',
            image: require('@/assets/product/courses/courses4.png'),
          },
        ],
        detailsTitle: 'コースの利点',
        details: [
          {
            title: '実践性が高い',
            description: '実践で理論をスキルに変換',
            image: require('@/assets/product/courses/icon1.png'),
          },
          {
            title: '創造的思考の育成',
            description: '手を動かしてデザイン、創造的に問題を解決',
            image: require('@/assets/product/courses/icon2.png'),
          },
          {
            title: 'プロジェクト駆動学習',
            description: 'プロジェクトを通じて学び、実践で知識を習得',
            image: require('@/assets/product/courses/icon3.png'),
          },
          {
            title: '最先端技術の探求',
            description: '最新技術に沿って学び、スマートキットの応用を習得',
            image: require('@/assets/product/courses/icon4.png'),
          },
          {
            title: '体系的な教育',
            description: 'コース内容は基礎から応用まで、理論から実践へ',
            image: require('@/assets/product/courses/icon5.png'),
          },
          {
            title: '楽しさと挑戦の両立',
            description:
              '楽しさで興味を引き、挑戦で能力を伸ばし、探究の中で成長',
            image: require('@/assets/product/courses/icon6.png'),
          },
        ],
      },
      ai: {
        title: '人工知能シリーズコース',
        items: [
          {
            name: 'スマートファーム',
            image: require('@/assets/product/courses/courses5.png'),
          },
          {
            name: 'スマートホーム',
            image: require('@/assets/product/courses/courses6.png'),
          },
          {
            name: 'スマート交通',
            image: require('@/assets/product/courses/courses7.png'),
          },
          {
            name: 'スマートファクトリー',
            image: require('@/assets/product/courses/courses8.png'),
          },
        ],
      },
      aiBanner: {
        alt: 'AIコースバナー',
        text: 'プロジェクト駆動、学際融合、実践・協力・問題解決能力を育成。安全性と個性を両立し、成果発表で達成感を向上、学生の成長を支援します。',
        image: require('@/assets/product/courses/banner1.png'),
      },
    },

    laser: {
      banner: {
        alt: 'レーザー製品',
        title: 'Good Laser レーザー製品',
        description:
          '安全で使いやすく、教育現場向けのレーザー切断/彫刻装置とソリューション',
        image: require('@/assets/product/laser/banner.png'),
      },
      advantagesTitle: '私たちの強み',
      extraNote: {
        light640_640:
          '優れた切断と彫刻の成果物\nさまざまなモデルとレーザー出力構成により、異なる用途のニーズに対応\nレーザータイプ: DC CO2  レーザー出力: 60W-130W',
      },
      center: {
        title: '製品センター',
        laser_accessories: 'レーザーアクセサリー',
        air_purifier_name: '空気清浄機',
        description:
          '学校の教育レベルに応じたレーザー装置の組み合わせプランを提供。Zetokは公式レーザー装置プランを4種類展開しており、学校は実際の教育ニーズに応じて購入できます。',
        tabs: [
          {
            key: 'light530',
            label: 'Light 530',
            images: Array(5).fill(
              require('@/assets/product/laser/light530.png')
            ),
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '高品質・高精度レーザー',
                bgColor: '#4285F4',
                description:
                  '高品質CO2レーザーチューブを採用、波長10640nm、55Wの高品質CO2レーザーを提供。最大切断厚さ20mm（アクリル）、作業速度600mm/s、繰り返し定位精度0.025mmにより、精密でクリエイティブな作品を迅速かつ正確に切断・彫刻可能。',
                image: require('@/assets/product/laser/light530-1.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '一体型三重排気フィルターシステム',
                bgColor: '#FFBC0C',
                description:
                  'フィルターネット、活性炭、UVオゾン層を備えた多層煙塵フィルターシステムの一体設計。より清潔で環境に優しく、製品設置も便利かつコンパクトで、別途フィルター装置を購入する必要がありません。',
                image: require('@/assets/product/laser/light530-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '最高水準の安全保護',
                bgColor: '#34A853',
                description:
                  'SGSラボでの最高安全テストをクリアし、FDA認証のクラスIレーザー製品。独自の安全および作業状態表示ライトで、機械の稼働状態を直感的に確認可能。',
                image: require('@/assets/product/laser/light530-3.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '操作簡単で強力なレーザー切断システム',
                bgColor: '#0F9D58',
                description:
                  '· 材料ごとに切断、深彫り、浅彫り、スキャンなどの加工パラメータ設定が可能。\n· 豊富な図面素材でデザイン効率を向上。\n· カメラによる位置撮影でデザイン補助、創造力を現実に。',
                image: require('@/assets/product/laser/light530-4.png'),
              },
            ],
          },
          {
            key: 'light640',
            label: 'Light 640',
            images: Array(5).fill(
              require('@/assets/product/laser/light640.png')
            ),
            models: [
              {
                key: '640',
                label: 'Light 640',
                image: require('@/assets/product/laser/640.png'),
              },
              {
                key: '960',
                label: 'Light 960',
                image: require('@/assets/product/laser/960.png'),
              },
              {
                key: '1390',
                label: 'Light 1390',
                image: require('@/assets/product/laser/1390.png'),
              },
              {
                key: '1610',
                label: 'Light 1610',
                image: require('@/assets/product/laser/1610.png'),
              },
            ],
            modelAdvantages: {
              640: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '作業範囲',
                  bgColor: '#4285F4',
                  description: `Light640 (600*400mm)
Light960 (900*600mm)
<br>Light1390 (1300*900mm)
<br>Light1610(1600*1000mm)`,
                  image: require('@/assets/product/laser/640-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '高効率オートフォーカス + レッドポイント定位',
                  bgColor: '#FFBC0C',
                  description:
                    '切断・彫刻前に迅速かつ正確にフォーカス可能。赤色ポイントで作業位置をリアルタイム確認可能。これによりLight640シリーズは切断・彫刻時間を大幅に節約し、精度の高い仕上がりを実現。',
                  image: require('@/assets/product/laser/640-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'オープンバックデザイン',
                  bgColor: '#34A853',
                  description:
                    'オープンバックにより、無制限長さの材料を設置可能。600mm x ∞の板材で作業がより便利になり、制限が少なくなります。',
                  image: require('@/assets/product/laser/640-3.png'),
                },
              ],
              960: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '優れた切断と彫刻の成果',
                  bgColor: '#4285F4',
                  description:
                    '広いレーザーカッティングプラットフォームを搭載し、木材やアクリルの加工において企業レベルの精度と効率を実現。大量生産も可能で、生産性と効率を飛躍的に向上。',
                  image: require('@/assets/product/laser/960-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '高品質レーザーチューブと精密コンポーネント搭載',
                  bgColor: '#FFBC0C',
                  description:
                    '多様な製品ラインで、用途に応じたレーザータイプと加工速度を選択可能。木材、ガラス、アクリルなどの加工に幅広い可能性を提供。',
                  image: require('@/assets/product/laser/960-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '厳格な光学テストによる品質保証',
                  bgColor: '#34A853',
                  description:
                    '厳しいテストと精密な光路制御、5回以上の切断・彫刻試験により、安定した光出力の最高品質CO2レーザーチューブを保証。パワー安定性とレーザースポットの精密さで均一な彫刻が可能。',
                  image: require('@/assets/product/laser/960-3.png'),
                },
              ],
              1390: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '包括的かつ高度な安全機能',
                  bgColor: '#4285F4',
                  description: `1. 緊急停止
<br>2. 警告ライト
<br>3. 防水スイッチ
<br>4. 接地線
<br>5. 内蔵熱検知アラームが異常時に自動作動
<br>6. フリップカバー保護
<br>7. 強化ガラス製耐久保護窓`,
                  image: require('@/assets/product/laser/1390-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '耐久性と卓越した品質',
                  bgColor: '#FFBC0C',
                  description: `1. 単品プロジェクトや大量生産に最適
<br>2. 作業範囲は600 x 400MMから1600 x 1000MMまで選択可能
<br>3. 卓越した彫刻速度
<br>4. 業界専門家による設計
<br>5. 個別化、教育、産業用途に理想的`,
                  image: require('@/assets/product/laser/1390-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'スマート監視による生産最適化',
                  bgColor: '#34A853',
                  description:
                    '機器の重要コンポーネント（軸、レーザーヘッド、光学部品、レンズ）をほこりや汚れから保護する設計で、長時間使用でも長年の故障なく稼働可能。',
                  image: require('@/assets/product/laser/1390-3.png'),
                },
              ],
              1610: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '高効率オートフォーカス + レッドポイント定位',
                  bgColor: '#4285F4',
                  description:
                    '切断・彫刻前に迅速かつ正確にフォーカス可能。赤色ポイントで作業位置をリアルタイム確認可能。Light 1610は時間を節約し、精度の高い仕上がりを実現。',
                  image: require('@/assets/product/laser/1610-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '優れた切断と彫刻の成果',
                  bgColor: '#FFBC0C',
                  description:
                    '広いレーザーカッティングプラットフォームにより、木材やアクリル加工で企業レベルの精度と効率を実現。大量生産も可能で、生産性を向上。',
                  image: require('@/assets/product/laser/1610-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '耐久性と卓越した品質',
                  bgColor: '#34A853',
                  description: `1. 単品プロジェクトや大量生産に最適
<br>2. 作業範囲は600 x 400MMから1600 x 1000MMまで
<br>3. 卓越した彫刻速度
<br>4. 専門家設計
<br>5. 個別化、教育、産業用途に理想的`,
                  image: require('@/assets/product/laser/1610-3.png'),
                },
              ],
            },
          },
          {
            key: 'lightblue530',
            label: 'Light Blue 530',
            images: Array(5).fill(
              require('@/assets/product/laser/blue530.png')
            ),
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '携帯型ブルーレイ彫刻機',
                bgColor: '#4285F4',
                description:
                  'スタイリッシュでコンパクト、どの家庭、学校、スタジオにも設置可能。金属ボディとアクリルカバーの組み合わせで、卓上に完璧に置け、強力な20Wレーザーで高精度切断が可能。',
                image: require('@/assets/product/laser/blue530-1.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '安全な閉鎖加工',
                bgColor: '#FFBC0C',
                description:
                  '全閉鎖式設計で、蓋を開けると自動停止。緊急時にはワンタッチで停止可能。家庭や学校向け。',
                image: require('@/assets/product/laser/blue530-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '多素材加工、100種類以上対応',
                bgColor: '#34A853',
                description:
                  '独自形状やスタイルのカスタム製品が可能。付属品で円形物体やカップ等も彫刻可能。小規模事業に最適。',
                image: require('@/assets/product/laser/blue530-3.png'),
              },
            ],
          },
          {
            key: 'markm20',
            label: 'Mark M20',
            images: Array(5).fill(require('@/assets/product/laser/m20.png')),
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '多用途な応用シーン',
                bgColor: '#4285F4',
                description:
                  'ジュエリー彫刻、個別アイテム、部品識別など多業界対応。ジュエリー、香水瓶、小型工業標識など多様なカスタム彫刻が可能。',
                image: require('@/assets/product/laser/m20.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '教育分野での革新的応用',
                bgColor: '#FFBC0C',
                description:
                  'Mark M20は工業レベル精度を教育分野に導入。基礎打刻技術から複雑プロジェクト開発能力まで育成。',
                image: require('@/assets/product/laser/m20-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'コンパクトでモダン',
                bgColor: '#34A853',
                description:
                  '小型・モダン設計、占有面積小、低騒音、大窓で耐久性高。教育機関や小売環境に最適。',
                image: require('@/assets/product/laser/m20-3.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '数秒でマーキング完了',
                bgColor: '#0F9D58',
                description:
                  '最小フォントでも数秒で正確にマーキング可能。LightMakerソフトと組み合わせで作業効率向上。',
                image: require('@/assets/product/laser/m20-4.png'),
              },
            ],
          },
          {
            key: 'accessories',
            label: 'アクセサリー',
            images: Array(5).fill(
              require('@/assets/product/laser/peijian.png')
            ),
            advantages: [
              {
                description: `· 使用場所：煙、臭気、粉塵、有害ガスなどの空気汚染が発生する場所に適用
<br>· 適用分野：電子・電気、玩具製造、精密金属、医療など
<br>· 設計特徴：可変式のシングル/デュアルワークステーション設計
<br>· フィルター装置：多層フィルター装置搭載
<br>· 風量調整：排気量に応じて無段階調整可能
<br>· 浄化効果：吸着・フィルター効率99.97%
<br>· 空気排出：浄化後の空気を室内に直接排出可能`,
                image: require('@/assets/product/laser/accessories1.png'),
              },
              {
                description: `· 装置タイプ：レーザー切断/彫刻補助装置
<br>· 用途：ワーク回転運動
<br>· 適用ワーク：円柱、チューブ形状等
<br>· 拡張機能：平面板材以外に円柱体加工も可能`,
                image: require('@/assets/product/laser/accessories2.png'),
              },
              {
                description: `· 高精度成形機
<br>· CNC制御で操作簡単
<br>· 複数の成形型が選択可能
<br>· クイッククランプで作業効率向上
<br>· 安全保護装置完備
<br>· 多種材料に対応`,
                image: require('@/assets/product/laser/accessories3.png'),
              },
            ],
          },
        ],
      },
    },
  },
  support: {
    afterSales: {
      banner: {
        alt: 'チュートリアルダウンロードのバナー',
        title: 'チュートリアルダウンロード',
        image: require('@/assets/after/banner.png'),
      },
      downloadText: 'チュートリアルをダウンロード',
      items: [
        {
          id: 'mk-1',
          name: 'スマートファーム',
          image: 'https://picsum.photos/seed/as-farm1/588/391',
          link: '#',
        },
        {
          id: 'mk-2',
          name: 'スマートホーム',
          image: 'https://picsum.photos/seed/as-home1/588/391',
          link: '#',
        },
        {
          id: 'mk-3',
          name: 'スマート交通',
          image: 'https://picsum.photos/seed/as-traffic1/588/391',
          link: '#',
        },
        {
          id: 'mk-4',
          name: 'スマートファクトリー',
          image: 'https://picsum.photos/seed/as-factory1/588/391',
          link: '#',
        },
        {
          id: 'mk-5',
          name: 'メーカースペース',
          image: 'https://picsum.photos/seed/as-makerspace1/588/391',
          link: '#',
        },
        {
          id: 'mk-6',
          name: 'ロボットコース',
          image: 'https://picsum.photos/seed/as-robot1/588/391',
          link: '#',
        },
        {
          id: 'mk-7',
          name: 'AI チュートリアル',
          image: 'https://picsum.photos/seed/as-ai1/588/391',
          link: '#',
        },
        {
          id: 'mk-8',
          name: 'IoT チュートリアル',
          image: 'https://picsum.photos/seed/as-iot1/588/391',
          link: '#',
        },
      ],
    },
  },
};
